import React, { useState } from "react";
import {
  Autocomplete,
  Grid,
  MenuItem,
  Select,
  TextField,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Input from "./Input";
import CustomButton from "./Button";
import {
  GuestCreation,
  getEmployeeDropdown,
  getEmployeeSuggestions,
} from "../Dashboard/mutations/guestCreation";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { handleToastMsg } from "./Toast";
import CameraComponent from "./CameraComponent";

const FormWrapper = styled(Grid)`
  padding: 4% 8%;
  /* 
  @media (min-width: 960px) {
    padding: 40px 80px;
  } */

  .MuiOutlinedInput-root {
    padding: 0;
  }

  .MuiAutocomplete-input {
    padding: 16px !important;
  }

  .MuiAutocomplete-root {
    padding: 0 !important;
  }

  .MuiOutlinedInput-root {
    padding: 0 !important;
  }

  .b {
    border: 1px solid;
  }
`;

function OrganizationGuestComponent({ isNotMobile = false, setStepper }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));

  const [visitorName, setVisitorName] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [organization, setOrganization] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);
  // const [options, setOptions] = useState([]);

  const [imageBoxVisible, setImageBoxVisible] = useState(true); // Track the ImageBox visibility
  const [mediaStream, setMediaStream] = useState(null);
  const [showCapture, setShowCapture] = useState(false);
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(GuestCreation);

  const { data: dropdownData } = useQuery("employee-relation-dropdown", () =>
    getEmployeeDropdown()
  );

  const { data: employeeSuggestions } = useQuery("employee-suggestion", () =>
    getEmployeeSuggestions()
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      visitor_name: visitorName,
      employee_name: employeeName,
      organization: organization,
      image: capturedImage,
    };

    mutate(payload, {
      onSuccess: (res) => {
        console.log({ res });
        queryClient.invalidateQueries("get-org-data");
        queryClient.invalidateQueries("get-relation-data");
        resetForm();
        clearImage();
        handleToastMsg("Entry added");
        if (isNotMobile) {
          setStepper("QUEUE");
        }
      },
      onError(err) {
        handleToastMsg(err.message, "Error Occured");
      },
    });
  };

  const resetForm = () => {
    setVisitorName("");
    setEmployeeName("");
    setOrganization("");
  };

  const clearImage = () => {
    setCapturedImage(null);
    mediaStream.getTracks().forEach((track) => track.stop());
    setImageBoxVisible(true);
    setShowCapture(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
      <FormWrapper item container rowGap={3} justifyContent={"center"}>
        <Grid container item md={6} xs={12} rowGap={3}>
          <Grid item md={10} xs={10} container>
            <Grid item xs={12} alignSelf={"center"} >
              Name
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                freeSolo
                options={employeeSuggestions ? employeeSuggestions.guests : []}
                onChange={(event, value) => setVisitorName(value)}
                style={{ padding: "14px 0px" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    type="text"
                    name="visitor_name"
                    value={visitorName}
                    onChange={(e) => setVisitorName(e.target.value)}
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid item md={10} xs={10} container>
            <Grid item xs={12} alignSelf={"center"}>
              Employee Name(Person to meet)
            </Grid>
            <Grid item xs={12}>
              <TextField
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
                style={{ width: "100%" }}
                select
              >
                {dropdownData ? (
                  dropdownData?.map((item) => (
                    <MenuItem value={item.name}>{item.name}</MenuItem>
                  ))
                ) : (
                  <MenuItem value={""}>No data found</MenuItem>
                )}
              </TextField>
            </Grid>
          </Grid>

          <Grid item md={10} xs={10} container>
            <Grid item xs={12} alignSelf={"center"}>
              Organisation
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="text"
                name="organization"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
                style={{
                  width: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container mt={{ xs: 2, md: 3 }} md={6} xs={12}>
          <CameraComponent
            capturedImage={capturedImage}
            setCapturedImage={setCapturedImage}
            setImageBoxVisible={setImageBoxVisible}
            imageBoxVisible={imageBoxVisible}
            setMediaStream={setMediaStream}
            mediaStream={mediaStream}
            showCapture={showCapture}
            setShowCapture={setShowCapture}
          />
        </Grid>
        <Grid
          item
          container
          xs={12}
          justifyContent={isMobile ? "center" : "flex-end"}
        >
          <CustomButton
            type={"submit"}
            disabled={!organization || !employeeName || !visitorName}
            isLoading={isLoading}
          >
            Submit / சமர்ப்பிக்க
          </CustomButton>
        </Grid>
      </FormWrapper>
    </form>
  );
}

export default OrganizationGuestComponent;
